import { Bus } from "front-toolkit/lib/bus"
export default new Bus()
